import {PointData} from "../types";

export default function spline(initPoints: PointData[], link?: boolean) {
	const len = initPoints.length;
	let points;
	if (len < 3) {
		points = initPoints;
	} else {
		let p0 = initPoints[0];
		let p1 = initPoints[0];
		let p2 = initPoints[1];
		let p3 = initPoints[2];
		points = [initPoints[0].slice(0,2)];
		for (let i = 1; i < len; i++) {
			points.push([
				((-p0[0] + 6 * p1[0] + p2[0]) / 6),
				((-p0[1] + 6 * p1[1] + p2[1]) / 6),
				((p1[0] + 6 * p2[0] - p3[0]) / 6),
				((p1[1] + 6 * p2[1] - p3[1]) / 6),
				p2[0],
				p2[1]
			]);
			p0 = p1;
			p1 = p2;
			p2 = p3;
			p3 = initPoints[i + 2] || p3;
		}
	}

	let d = "";
	for (let i = 0; i < points.length; i++) {
		const point = points[i];
		const n = point.length;
		if (!i) {
			d += (link?"L":"M")+`${point[n - 2]} ${point[n - 1]}`;
		} else if (n > 4) {
			d += `C${point[0]} ${point[1]}
				${point[2]} ${point[3]}
				${point[4]} ${point[5]}`;
		} else {
			d += `S${point[0]} ${point[1]}
				${point[2]} ${point[3]}`;
		}
	}
	return d;
}